import { Injectable, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
// Layout antigo mantido como referência para rollback:
//import { LayoutComponent } from '@app/shared/components/layout/layout.component';
import { LayoutV2Component as LayoutComponent } from '@app/shared/components/layout-v2/layout-v2.component';
import { PatronNavData } from 'src/app/models/core-config.model';
import { AuthComponent } from './auth.component';
import { AuthGuard } from './auth.guard';
import { AuthService } from './auth.service';
import { BwUserListComponent } from './bw-users/bw-user-list/bw-user-list.component';
import { BwUserViewComponent } from './bw-users/bw-user-view/bw-user-view.component';
import { BwUsersPendingListComponent } from './bw-users/bw-users-pending-list/bw-users-pending-list.component';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { ConfirmEmailComponent } from './confirm-email/confirm-email.component';
import { AuthLayoutComponent } from './layout/layout.component';
import { PageForbiddenComponent } from './page-forbidden/page-forbidden';
import { PageNotFoundComponent } from './page-not-found/page-not-found';
import { ProfileModulesGuard } from './profile-modules.guard';
import { ProfileComponent } from './profile/profile.component';
import { ProfileFormComponent } from './profiles/profile-form/profile-form.component';
import { ProfilesComponent } from './profiles/profiles.component';
import { RegisterCompanyComponent } from './register-company/register-company.component';
import { NewPasswordComponent } from './reset-password/new-password/new-password.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { ServerErrorComponent } from './server-error/server-error.component';
import { VersionHistoryComponent } from './version-history/version-history.component';
@Injectable({ providedIn: 'root' })
export class NavItemsResolver {
  constructor(private service: AuthService) {}

  resolve(): PatronNavData[] | undefined {
    return this.service.getCoreConfig().navItems;
  }
}

const routes: Routes = [
  {
    path: '',
    component: AuthLayoutComponent,
    children: [
      {
        path: 'auth',
        component: AuthComponent,
        data: { title: 'Entrar' },
      },
      {
        path: 'cadastrar-empresa',
        component: RegisterCompanyComponent,
        data: { title: 'Cadastrar empresa' },
      },
      {
        path: 'recuperar-senha',
        component: ResetPasswordComponent,
        data: { title: 'Recuperar senha' },
      },
      {
        path: 'nova-senha',
        component: NewPasswordComponent,
        data: { title: 'Nova senha' },
      },
    ],
  },
  {
    path: '',
    component: LayoutComponent,
    resolve: { navItems: NavItemsResolver },
    children: [
      {
        path: 'usuarios',
        component: BwUserListComponent,
        canActivate: [AuthGuard, ProfileModulesGuard],
        data: {
          title: 'Usuários',
          requiredModules: ['Users'],
          onlyCompanyUsers: true,
        },
      },
      {
        path: 'usuarios/:id',
        component: BwUserViewComponent,
        canActivate: [AuthGuard, ProfileModulesGuard],
        data: {
          title: 'Cadastro do usuário',
          requiredModules: ['Users'],
          onlyCompanyUsers: true,
        },
      },
      {
        path: 'perfis',
        component: ProfilesComponent,
        canActivate: [AuthGuard, ProfileModulesGuard],
        data: {
          title: 'Perfis',
          requiredModules: ['Users'],
          onlyCompanyUsers: true,
        },
      },
      {
        path: 'perfis/criar',
        component: ProfileFormComponent,
        canActivate: [AuthGuard, ProfileModulesGuard],
        data: {
          title: 'Cadastro de perfil',
          requiredModules: ['Users'],
          onlyCompanyUsers: true,
        },
      },
      {
        path: 'perfis/:id',
        component: ProfileFormComponent,
        canActivate: [AuthGuard, ProfileModulesGuard],
        data: {
          title: 'Cadastro de perfil',
          requiredModules: ['Users'],
          onlyCompanyUsers: true,
        },
      },
      {
        path: 'notificacoes',
        loadChildren: () =>
          import('../shared/components/notification/notification.module').then(
            m => m.NotificationModule
          ),
        canActivate: [AuthGuard, ProfileModulesGuard],
        data: {
          title: 'Notificações',
          requiredModules: ['Notifications'],
        },
      },
      {
        path: 'usuarios-pendentes',
        component: BwUsersPendingListComponent,
        canActivate: [AuthGuard, ProfileModulesGuard],
        data: {
          title: 'Usuários pendentes',
          requiredModules: ['Users'],
          onlyCompanyUsers: true,
        },
      },
      {
        path: 'perfil',
        component: ProfileComponent,
        canActivate: [AuthGuard],
        data: { title: 'Perfil' },
      },
      {
        path: 'confirmar-email',
        component: ConfirmEmailComponent,
        canActivate: [AuthGuard],
        data: { title: 'Confirmar email' },
      },
      {
        path: 'alterar-senha',
        component: ChangePasswordComponent,
        canActivate: [AuthGuard],
        data: { title: 'Alterar senha' },
      },
    ],
  },
  {
    path: 'versoes',
    component: VersionHistoryComponent,
    data: { title: 'Versões' },
  },
  {
    path: 'server-error',
    pathMatch: 'full',
    component: ServerErrorComponent,
  },
  {
    path: 'acesso-negado',
    pathMatch: 'full',
    component: PageForbiddenComponent,
    data: { title: '403 - Acesso Negado' },
  },
  {
    path: '**',
    pathMatch: 'full',
    component: PageNotFoundComponent,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AuthRoutingModule {}
